<script>
    /**
     * @typedef {import('../../services/ValueService.js').ValueCssColor} ValueCssColor
     */

    import { getContext, setContext } from 'svelte';
    import { ValueService } from '../../services/ValueService.js';

    /**
     * @type {{
     *     bg?: boolean | string | null,
     *     children?: import("svelte").Snippet,
     * }}
     */
    let { bg = null, children } = $props();

    const tableBg = $derived(getContext('ly-table-colors')?.value?.next);
    const tableHeadBg = $derived(getContext('ly-table-thead-colors')?.value?.next);
    const useBg = $derived(bg !== null ? bg : (tableHeadBg ?? tableBg ?? true));

    /** @type {{value:ValueCssColor|null}} */
    let colors = $state({ value: null });
    $effect(() => {
        colors.value = ValueService.splitCssColor(useBg, true);
    });
    setContext('ly-table-thead-row-colors', colors);
</script>

<tr>
    {@render children?.()}
</tr>
